import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import "./format-19.style.scss";
import { Container, Row, Col } from "react-bootstrap";

const Format19 = (props) => {
  const [data, setData] = useState({});
  useEffect(() => {
    if (props?.item) {
      setData(props.item);
    }
  }, [props.item]);
  const checkValue = (val) => val && val !== "";
  return (
    <Container bsPrefix="container-xl format-19" key={props.keyUniq}>
      <div className="content">
        {checkValue(data.image) && (
          <div className="overlay-image-container">
            <img
              src={data.image}
              alt="Pondasi Program"
              className="overlay-image-only"
            />
          </div>
        )}
        {checkValue(data?.name) && (
          <Row className="title">
            <h1 className="title-text">{data.name}</h1>
          </Row>
        )}

        {checkValue(data.desc) && (
          <Row className="desc mt-4">
            {parse(data.desc)}
          </Row>
        )}

        <div className="btn-back-container">
          <button className="btn-back" onClick={() => window.history.back()}>
            <i className="fa fa-chevron-left"></i>
            <span>Kembali</span>
          </button>
        </div>
      </div>
    </Container>
  );
};

export default Format19;